export default __webpack_public_path__ + "static/media/starting-gift.f6591641.svg";